import { getRole } from './framework'
import { personById } from './demoOrganisation'

export type ReportType = 'Individual' | 'Board Aggregate' | 'Executive Summary'

export type Report = {
  id: string
  title: string
  type: ReportType
  cycle: string
  date: string
  size: string
  /** Framework role ids the report covers. */
  roleIds: string[]
  /** Competency domain names highlighted in the report. */
  domains: string[]
}

export const CURRENT_CYCLE = '2026 Board & Executive Review'
const PREVIOUS_CYCLE = '2025 Board & Executive Review'

/** Domain names for a role by index, so tags always match the framework. */
function domainNames(roleId: string, indexes: number[]): string[] {
  const role = getRole(roleId)
  if (!role) return []
  return indexes
    .map((i) => role.domains[i]?.name)
    .filter((n): n is string => Boolean(n))
}

function individual(
  id: string,
  personId: string,
  cycle: string,
  date: string,
  size: string,
  domainIndexes: number[],
): Report {
  const p = personById(personId)
  return {
    id,
    title: `${p.name} — ${p.title} Report`,
    type: 'Individual',
    cycle,
    date,
    size,
    roleIds: [p.roleId],
    domains: domainNames(p.roleId, domainIndexes),
  }
}

export const REPORTS: Report[] = [
  individual('rep_1', 'p2', CURRENT_CYCLE, 'Oct 15, 2026', '2.4 MB', [0, 1, 4]),
  individual('rep_2', 'p3', CURRENT_CYCLE, 'Oct 14, 2026', '2.1 MB', [2, 3]),
  individual('rep_3', 'p1', CURRENT_CYCLE, 'Oct 12, 2026', '1.9 MB', [0, 5]),
  individual('rep_4', 'p8', CURRENT_CYCLE, 'Oct 10, 2026', '2.5 MB', [0, 3, 6]),
  individual('rep_5', 'p5', CURRENT_CYCLE, 'Oct 09, 2026', '2.2 MB', [3, 4]),
  {
    id: 'rep_6',
    title: 'Board of Directors — Aggregate Report',
    type: 'Board Aggregate',
    cycle: CURRENT_CYCLE,
    date: 'Oct 16, 2026',
    size: '4.2 MB',
    roleIds: ['board-chair', 'ned', 'ined', 'audit-chair', 'nominations-chair'],
    domains: domainNames('ned', [0, 1, 2]),
  },
  {
    id: 'rep_7',
    title: '2026 Executive Summary',
    type: 'Executive Summary',
    cycle: CURRENT_CYCLE,
    date: 'Oct 18, 2026',
    size: '5.1 MB',
    roleIds: ['ceo', 'cfo', 'coo', 'cro', 'cio', 'cmo'],
    domains: domainNames('ceo', [0, 1]),
  },
  individual('rep_8', 'p2', PREVIOUS_CYCLE, 'Oct 12, 2025', '2.3 MB', [0, 1]),
  individual('rep_9', 'p3', PREVIOUS_CYCLE, 'Oct 10, 2025', '2.4 MB', [2]),
  {
    id: 'rep_10',
    title: '2025 Executive Summary',
    type: 'Executive Summary',
    cycle: PREVIOUS_CYCLE,
    date: 'Oct 20, 2025',
    size: '4.8 MB',
    roleIds: ['ceo', 'cfo', 'coo', 'cro'],
    domains: domainNames('ceo', [0, 2]),
  },
]
